/**
 * Adds an optional prefix to a Formik field name.
 * Used to avoid name collisions in a formik.
 */
export const buildFieldName = (name: string, fieldNamePrefix?: string): string =>
  fieldNamePrefix ? `${fieldNamePrefix}.${name}` : name;
